

export class PaymentSystemEnum {
    
	static None: number = 0; 
	static Braintree: number = 1; 
	static CardX: number = 2; 
	static Eschelon: number = 3; 


	static getChoices(): any[] {
		return [
		{
			Value: PaymentSystemEnum.None, Text: 'None'
	},{
			Value: PaymentSystemEnum.Braintree, Text: 'Braintree'
	},{
			Value: PaymentSystemEnum.CardX, Text: 'Card X'
	},{
			Value: PaymentSystemEnum.Eschelon, Text: 'Eschelon'
	}
			
		];
	}

}
